
import React from 'react';
import { useNavigate } from 'react-router-dom';
import IntellendLogo from "@/components/IntellendLogo";
import { useAuth } from "@/contexts/AuthContext";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { User, LogOut } from "lucide-react";

interface HeaderProps {
	className?: string;
}

const Header: React.FC<HeaderProps> = ({ className }) => {
	const { user, logout } = useAuth();
	const navigate = useNavigate();

	const handleLogout = async () => {
		await logout();
		navigate('/home');
	};

	// Only show user menu if user is logged in
	const showUserMenu = !!user;

	return (
		<header className={`bg-intellend-green p-3 ${className || ''}`}>
			<div className="container mx-auto flex justify-between items-center">
				<div className="bg-intellend-white p-1 rounded-md">
					<IntellendLogo size="sm" />
				</div>

				{showUserMenu && (
					<DropdownMenu>
						<DropdownMenuTrigger asChild>
							<Button variant="ghost" size="icon" className="group rounded-full bg-intellend-white hover:bg-intellend-white/90 text-intellend-green">
								<User className="h-5 w-5" />
								<span className="sr-only">Open user menu</span>
							</Button>
						</DropdownMenuTrigger>
						<DropdownMenuContent align="end" className="w-56">
							<DropdownMenuItem onClick={handleLogout} className="cursor-pointer text-red-600 focus:text-red-600">
								<LogOut className="mr-2 h-4 w-4" />
								<span>Log out</span>
							</DropdownMenuItem>
						</DropdownMenuContent>
					</DropdownMenu>
				)}
			</div>
		</header>
	);
};

export default Header;
